import { useCallback, useLayoutEffect, useState } from 'react';

import { useAppContext } from '@/contexts/app';

import { getAvailableClients } from '@/services/Users';

export const useClientButton = () => {
  const { handleAlert } = useAppContext();

  const [clients, setClients] = useState([]);
  const [searchText, setSearchText] = useState('');

  useLayoutEffect(() => {
    const loadClients = async () => {
      try {
        const clientsList = await getAvailableClients();

        setClients(clientsList);
      } catch (error) {
        handleAlert(error, 'error');
      }
    };

    loadClients();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = useCallback((e) => setSearchText(e.target.value), []);

  return {
    clients,
    searchText,
    handleChange,
  };
};
